import React from 'react';
import styled from 'styled-components';
import {Trans, useTranslation} from 'react-i18next';

import config from 'utils/config';

import {spacing} from 'styles/globals';

import Button from 'components/Button';
import Flag from 'components/Flag';
import Popover from 'components/Popover';
import Portal from 'components/Portal';

import browserCheck from 'utils/serviceworker/tools/browserCheck.js';

const device = browserCheck() || 'device';

const closeButtonSafeZone = spacing.xl;

const IosTooltipTarget = styled.div`
	position: fixed;
	bottom: 2px;
	left: 50vw;
	width: 1px;
	height: 1px;

	@media (min-width: 640px) {
		bottom: auto;
		left: auto;
		top: 2px;
		right: 120px;
	}

	@media (min-width: 724px) {
		right: 110px;
	}

	@media (min-width: 768px) {
		right: 140px;
	}
`;

const AppIcon = styled.img`
	overflow: hidden;
	border-radius: 8px;
	background-color: white;
`;

function ShareIcon({children}) {
	return (
		<svg
			role="img"
			aria-label={children}
			version="1.1"
			xmlns="http://www.w3.org/2000/svg"
			xmlnsXlink="http://www.w3.org/1999/xlink"
			x="0px"
			y="0px"
			viewBox="0 0 1000 1000"
			xmlSpace="preserve"
			style={{marginTop: -5}}
		>
			<path
				fill="#00D3F9"
				d="M381.9,181l95.8-95.8v525.9c0,13.4,8.9,22.3,22.3,22.3c13.4,0,22.3-8.9,22.3-22.3V85.2l95.8,95.8c4.5,4.5,8.9,6.7,15.6,6.7c6.7,0,11.1-2.2,15.6-6.7c8.9-8.9,8.9-22.3,0-31.2L515.6,16.1c-2.2-2.2-4.5-4.5-6.7-4.5c-4.5-2.2-11.1-2.2-17.8,0c-2.2,2.2-4.5,2.2-6.7,4.5L350.7,149.8c-8.9,8.9-8.9,22.3,0,31.2C359.6,190,373,190,381.9,181z M812,276.9H633.7v44.6H812v624H188v-624h178.3v-44.6H188c-24.5,0-44.6,20.1-44.6,44.6v624c0,24.5,20.1,44.6,44.6,44.6h624c24.5,0,44.6-20.1,44.6-44.6v-624C856.6,296.9,836.5,276.9,812,276.9z"
			/>
		</svg>
	);
}

function IosTooltip({onClose}) {
	const {t} = useTranslation();

	const pageTitle = config.shortName || config.pageTitle || 'Learning Hub';

	return (
		<Flag
			token={
				<AppIcon
					src={`${config.brand_path}/favicons/apple-touch-icon.png`}
					width="36"
					height="36"
					alt=""
				/>
			}
			maxWidth={340}
			mr={closeButtonSafeZone}
		>
			<Trans
				t={t}
				i18nKey="add_to_homescreen_ios_instructions"
				defaults="Install {{pageTitle}} on your {{device}}: Tap <0>the 'Share' icon</0> and then 'Add to Home Screen'."
				values={{pageTitle, device}}
				components={[<ShareIcon key="1">Share icon</ShareIcon>]}
			/>
			<Button
				icon="x"
				size="small"
				variant="transparent"
				onClick={onClose}
				position="absolute"
				top="xs"
				right="xs"
			/>
		</Flag>
	);
}

function IosHint({onClose}) {
	return (
		<Popover
			isOpen
			content={<IosTooltip onClose={onClose} />}
			variant="inverted"
			p="xs"
			fontSize="s"
		>
			{({ref}) => (
				<Portal>
					<IosTooltipTarget ref={ref} />
				</Portal>
			)}
		</Popover>
	);
}

export default IosHint;
